/**
 * Tool name suffix for the create_subagent MCP tool. We match by suffix
 * because MCP can namespace tools (e.g. `mcp__epx-agent__create_subagent`).
 */
export const SUBAGENT_TOOL_NAME_SUFFIX = 'create_subagent';

const CHILD_CHAT_NAME_RE = /^(projects\/[^/]+\/)?chats\/[^/\s]+$/;

/**
 * The create_subagent tool returns the child chat's resource name as the
 * single text part of its tool_result content. Parse it back out.
 */
export const parseChildChatName = (
  content: string | null | undefined,
): string | null => {
  if (!content) return null;
  const trimmed = content.trim();
  return CHILD_CHAT_NAME_RE.test(trimmed) ? trimmed : null;
};
